@if (taxesForm != null) {
  <div class="tab-wrapper">
    <form [formGroup]="taxesForm">
      <div class="row">
        <div class="col-xl-6">
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['federalTaxes'] }"
            *ngIf="authService.canRead('employee_federal_taxes_panel')">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('federalTaxes')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['federalTaxes'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Federal Taxes</h3>
              <ng-template #exemptTooltip>
                <div class="text-start">
                  Person may claim exemption from withholding if both of the following apply.<br />
                  <ul>
                    <li>
                      For prior year, person had a right to a refund of all federal income tax
                      withheld because they had no tax liability, and
                    </li>
                    <li>
                      For this year person expects a refund of all federal income tax withheld
                      because you expect to have no tax liability
                    </li>
                  </ul>
                  NOTE: This person’s wages will be reported to the IRS.
                </div>
              </ng-template>
              <div class="row" *hasPermission="'employee_federal_taxes_exempt_from_withholding'">
                <div class="col-lg-12">
                  <input
                    formControlName="IsExemptFromWithholding"
                    type="checkbox"
                    id="wh-exempt-cb"
                    value="true" />
                  <label for="wh-exempt-cb" [ngbTooltip]="exemptTooltip"
                    ><span></span>Exempt from withholding</label
                  >
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_w4_version'">
                <div class="col-lg-12">
                  <label>Which form W-4 will be used to define withholding elections?</label>
                  <div class="radio-group flex-wrap">
                    <div>
                      <input
                        type="radio"
                        id="w4-version-00-radio"
                        formControlName="W4Version"
                        name="W4Version"
                        value="1" />
                      <label for="w4-version-00-radio"
                        ><span></span>Form W-4 Employee's Withholding Certificate 2020 or
                        later</label
                      >
                      &nbsp;&nbsp;&nbsp;
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="w4-version-01-radio"
                        formControlName="W4Version"
                        name="W4Version"
                        value="0" />
                      <label for="w4-version-01-radio"
                        ><span></span>Form W-4 Employee's Withholding Allowance Certification prior
                        to 2020</label
                      >
                      &nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_filing_status'">
                <div class="col-lg-12">
                  <label>Federal Filing Status</label>
                  <select
                    appAutoFocus
                    formControlName="FederalFilingStatus"
                    class="form-control"
                    [attr.disabled]="
                      f.IsExemptFromWithholding.value || f.FederalFilingStatus.disabled
                        ? 'disabled'
                        : null
                    ">
                    <option
                      *ngFor="let status of getFederalFilingStatuses() | async"
                      [value]="status.Id">
                      {{ status.Value }}
                    </option>
                  </select>
                  <div *ngIf="f.FederalFilingStatus.errors?.required" class="input-error">
                    *required
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_is_higher_withholding'">
                <div class="col-lg-12" *ngIf="f.W4Version.value == 1">
                  <input
                    formControlName="IsHigherWithholding"
                    type="checkbox"
                    id="wh-higher-cb"
                    value="true"
                    [attr.disabled]="
                      f.IsExemptFromWithholding.value || f.IsHigherWithholding.disabled
                        ? 'disabled'
                        : null
                    " />
                  <label for="wh-higher-cb"
                    ><span></span>The box in Step 2 of Form W-4 (multiple jobs/higher withholding)
                    is checked</label
                  >
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_child_tax_credit'">
                <div class="col-lg-12" *ngIf="f.W4Version.value == 1">
                  <label>Child & dependent tax credit - full year amount</label
                  ><small class="text-muted"> [Form w-4 Line 3]</small>
                  <div class="input-group">
                    <input
                      class="form-control"
                      [formControl]="getControl('ChildTaxCredit')"
                      appNumberInput
                      [attr.disabled]="
                        f.IsExemptFromWithholding.value || f.ChildTaxCredit.disabled
                          ? 'disabled'
                          : null
                      " />
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_other_income'">
                <div class="col-lg-12" *ngIf="f.W4Version.value == 1">
                  <label>Other (non-wage) income - full year amount</label
                  ><small class="text-muted">
                    [Form W-4 Line 4a] Taxable wage will be increased by this amount</small
                  >
                  <div class="input-group">
                    <input
                      class="form-control"
                      [formControl]="getControl('OtherIncome')"
                      appNumberInput
                      [attr.disabled]="
                        f.IsExemptFromWithholding.value || f.OtherIncome.disabled
                          ? 'disabled'
                          : null
                      " />
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_wage_deduction'">
                <div class="col-lg-12" *ngIf="f.W4Version.value == 1">
                  <label>Deduction - full year amount</label
                  ><small class="text-muted">
                    [Form W-4 Line 4b] Taxable wage will be decreased by this amount</small
                  >
                  <div class="input-group">
                    <input
                      class="form-control"
                      [formControl]="getControl('WageDeduction')"
                      appNumberInput
                      [attr.disabled]="
                        f.IsExemptFromWithholding.value || f.WageDeduction.disabled
                          ? 'disabled'
                          : null
                      " />
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_withholding_allowance'">
                <div class="col-lg-12" *ngIf="f.W4Version.value == 0">
                  <label>Federal Withholding Allowance</label>
                  <input
                    [formControl]="getControl('FederalWithholdingAllowance')"
                    class="form-control"
                    maxlength="2"
                    appNumberInput
                    [decimals]="0"
                    [attr.disabled]="
                      f.IsExemptFromWithholding.value || f.FederalWithholdingAllowance.disabled
                        ? 'disabled'
                        : null
                    " />
                  <div *ngIf="f.FederalWithholdingAllowance.errors?.maxlength" class="input-error">
                    *max number exceeded
                  </div>
                </div>
              </div>
              <ng-template #addlDollarAfter2020Tooltip>
                <div class="text-start">
                  Extra withholding – per payroll amount <br /><span class="text-muted"
                    >[Form W-4 Line 4c]</span
                  >
                </div>
              </ng-template>
              <ng-template #addlDollarPre2020Tooltip>
                <div class="text-start">Extra withholding – per payroll amount</div>
              </ng-template>
              <ng-template #fixedDollarTooltip>
                <div class="text-start">
                  Fixed dollar tax election will be taken each payroll and overrides all other
                  selections (filing status, exemptions, credits, etc.)
                </div>
              </ng-template>
              <ng-template #fixedPercentTooltip>
                <div class="text-start">
                  Fixed percent tax election amount will be taken each payroll and overrides all
                  other selections (filing status, exemptions, credits, etc.)
                </div>
              </ng-template>
              <div class="row" *hasPermission="'employee_federal_taxes_fixed_withholding_type'">
                <div class="col-lg-12">
                  <label>Fixed or Additional Withholdings</label>
                  <div class="radio-group flex-wrap justify-content-between">
                    <div>
                      <input
                        type="radio"
                        id="federal-wh-radio-none"
                        name="FederalAddlWithholdingType"
                        [attr.disabled]="f.IsExemptFromWithholding.value ? 'disabled' : null"
                        formControlName="FederalAddlWithholdingType"
                        checked="true"
                        value="null" />
                      <label for="federal-wh-radio-none"><span></span>None</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="federal-wh-radio-additional-dollar"
                        name="FederalAddlWithholdingType"
                        [attr.disabled]="f.IsExemptFromWithholding.value ? 'disabled' : null"
                        formControlName="FederalAddlWithholdingType"
                        value="A" />
                      <label
                        for="federal-wh-radio-additional-dollar"
                        [ngbTooltip]="
                          f.W4Version.value == 0
                            ? addlDollarPre2020Tooltip
                            : addlDollarAfter2020Tooltip
                        ">
                        <span></span>Additional Dollar
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="federal-wh-radio-fixed-dollar"
                        formControlName="FederalAddlWithholdingType"
                        [attr.disabled]="f.IsExemptFromWithholding.value ? 'disabled' : null"
                        name="FederalAddlWithholdingType"
                        value="F" />
                      <label for="federal-wh-radio-fixed-dollar" [ngbTooltip]="fixedDollarTooltip">
                        <span></span>Fixed Dollar
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="federal-wh-radio-fixed-percent"
                        formControlName="FederalAddlWithholdingType"
                        [attr.disabled]="f.IsExemptFromWithholding.value ? 'disabled' : null"
                        name="FederalAddlWithholdingType"
                        value="P" />
                      <label
                        for="federal-wh-radio-fixed-percent"
                        [ngbTooltip]="fixedPercentTooltip">
                        <span></span>Fixed Percent
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_federal_taxes_fixed_withholding_value'">
                <div class="col-lg-12" *ngIf="f.FederalAddlWithholdingType.value != 'null'">
                  <div class="input-group">
                    <input
                      appNumberInput
                      [formControl]="getControl('FederalAddlWithholdingValue')"
                      class="form-control"
                      [attr.disabled]="
                        f.FederalAddlWithholdingValue.disabled ? 'disabled' : null
                      " />
                    <!-- additional dollar or fixed dollar -->
                    <div
                      class="input-group-prepend"
                      *ngIf="
                        f.FederalAddlWithholdingType.value == 'A' ||
                        f.FederalAddlWithholdingType.value == 'F'
                      ">
                      <span class="input-group-text">$</span>
                    </div>
                    <!-- fixed percent -->
                    <div
                      class="input-group-append"
                      *ngIf="f.FederalAddlWithholdingType.value == 'P'">
                      <span class="input-group-text">%</span>
                    </div>
                    <div
                      *ngIf="
                        !f.FederalAddlWithholdingValue.errors?.required &&
                        f.FederalAddlWithholdingValue.errors
                      "
                      class="input-error input-group-error">
                      *invalid number
                    </div>
                    <div
                      *ngIf="f.FederalAddlWithholdingValue.errors?.required"
                      class="input-error input-group-error">
                      *required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            [ngClass]="{
              'expanded-card': cardExpanders['taxExemptions'],
              readOnly: isClientPortal
            }"
            *ngIf="authService.canRead('employee_tax_exemptions_panel')">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('taxExemptions')"
                title="toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['taxExemptions'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">Tax Exemptions and Visa</h3>
              <div class="row">
                <div class="col-lg-12">
                  <label>Tax Exemptions</label>
                </div>
              </div>
              <div class="position-relative">
                <div class="row">
                  <div class="checkbox-group justify-content-between">
                    <div class="col-3" *hasPermission="'employee_taxes_ss_exemption'">
                      <input
                        formControlName="HasSSExemption"
                        type="checkbox"
                        id="exemptions-cb-ss"
                        value="true" />
                      <label for="exemptions-cb-ss"><span></span>SS</label>
                    </div>
                    <div class="col-3" *hasPermission="'employee_taxes_medc_exemption'">
                      <input
                        formControlName="HasMEDCExemption"
                        type="checkbox"
                        id="exemptions-cb-medc"
                        value="true" />
                      <label for="exemptions-cb-medc"><span></span>MEDC</label>
                    </div>
                    <div class="col-3" *hasPermission="'employee_taxes_sui_exemption'">
                      <input
                        formControlName="HasSUIExemption"
                        type="checkbox"
                        id="exemptions-cb-sui"
                        value="true" />
                      <label for="exemptions-cb-sui"><span></span>SUI</label>
                    </div>
                    <div class="col-3" *hasPermission="'employee_taxes_futa_exemption'">
                      <input
                        formControlName="HasFUTAExemption"
                        type="checkbox"
                        id="exemptions-cb-futa"
                        value="true" />
                      <label for="exemptions-cb-futa"><span></span>FUTA</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="checkbox-group">
                    <div class="col-4" *ngIf="showAddlTaxExemption('HasFamilyLeaveExempt') | async">
                      <div *hasPermission="'employee_taxes_family_leave_exemption'">
                        <input
                          formControlName="HasFamilyLeaveExempt"
                          type="checkbox"
                          id="exemptions-fam-leave"
                          value="true" />
                        <label for="exemptions-fam-leave"><span></span>Family Leave</label>
                      </div>
                    </div>
                    <div class="col-4" *ngIf="showAddlTaxExemption('HasMedLeaveExempt') | async">
                      <div *hasPermission="'employee_taxes_med_leave_exemption'">
                        <input
                          formControlName="HasMedLeaveExempt"
                          type="checkbox"
                          id="exemptions-med-leave"
                          value="true" />
                        <label for="exemptions-med-leave"><span></span>Medical Leave</label>
                      </div>
                    </div>
                    <div class="col-4" *ngIf="showAddlTaxExemption('HasDisLeaveExempt') | async">
                      <div *hasPermission="'employee_taxes_disab_leave_exemption'">
                        <input
                          formControlName="HasDisLeaveExempt"
                          type="checkbox"
                          id="exemptions-disab-leave"
                          value="true" />
                        <label for="exemptions-disab-leave"><span></span>Disability Leave</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showJ1F1VisaWarning && !showJ1F1ExpirationMsg"
                  class="input-error"
                  style="top: unset; bottom: 0">
                  *Should be SS and MEDC exempt
                </div>
              </div>
              <div class="row" *hasPermission="'employee_taxes_futa_exemption_reason'">
                <div class="col-lg-12">
                  <label>FUTA Exemption Reason</label>
                  <select formControlName="FUTAExemptionReason" class="form-control">
                    <option></option>
                    <option *ngFor="let r of futaReasons" value="{{ r.Id }}">
                      {{ r.Value }}
                    </option>
                  </select>
                  <div *ngIf="f.FUTAExemptionReason.errors?.required" class="input-error">
                    *required
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_taxes_j1_f1_visa'">
                <div class="col-lg-12">
                  <label>J1/F1 Visa</label>
                  <div class="radio-group">
                    <div>
                      <input
                        type="radio"
                        id="j1-f1-radio-no"
                        formControlName="J1F1Visa"
                        name="J1F1Visa"
                        value="0" />
                      <label for="j1-f1-radio-no"><span></span>No</label>
                    </div>
                    <div class="radio-options-spacer"></div>
                    <div>
                      <input
                        type="radio"
                        id="j1-f1-radio-yes"
                        formControlName="J1F1Visa"
                        name="J1F1Visa"
                        value="1" />
                      <label for="j1-f1-radio-yes"><span></span>Yes</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *hasPermission="'employee_taxes_visa_expire_date'">
                <div class="col-lg-12">
                  <label>Visa Expire Date</label>
                  <div class="input-group">
                    <input
                      formControlName="ExpireDate"
                      class="form-control datepicker"
                      ngbDatepicker
                      [placement]="['bottom-end', 'top-end']"
                      #expiredatepicker="ngbDatepicker"
                      [firstDayOfWeek]="7" />
                    <div
                      *ngIf="f.ExpireDate.value && !f.ExpireDate.valid"
                      class="input-error input-group-error">
                      *invalid date
                    </div>
                    <div
                      *ngIf="
                        showJ1F1ExpirationMsg &&
                        (f.HasSSExemption.value == true || f.HasMEDCExemption.value == true)
                      "
                      class="input-error input-group-error">
                      &nbsp; *Employees J1/F1 Visa has expired. Remove SS and MEDC checks if this
                      person is no longer exempt.
                    </div>
                    <img
                      src="assets/icons/calendar.svg"
                      (click)="expiredatepicker.toggle()"
                      class="icon-append" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['stateTaxes'] }"
            *ngIf="authService.canRead('employee_state_taxes_panel')">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('stateTaxes')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['stateTaxes'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">State Taxes</h3>
              <div class="row" *hasPermission="'employee_state_taxes_withholding_state'">
                <div class="col-lg-12">
                  <label>Withholding in which State</label>
                  <select
                    formControlName="WithHoldingState"
                    class="form-control"
                    (change)="onStateTaxElectionChange($event, null)">
                    <option></option>
                    <!--
                      'Both' option(s) here. In some edge case scenarios with invalid tax setups, there can be more than 1
                    -->
                    <option *ngFor="let both of bothWHStateOpts" value="{{ both.key }}">
                      {{ both.value }}
                    </option>
                    <option *ngFor="let state of withHoldingStateIds" value="{{ state }}">
                      {{ getStateName(state) | async }}
                    </option>
                  </select>
                  <div *ngIf="f.WithHoldingState.disabled" class="input-error show-untouched">
                    &nbsp;Works in state required on Job Details page
                  </div>
                  <div
                    *ngIf="!invalidTaxMessage && f.WithHoldingState.errors?.required"
                    class="input-error">
                    *required
                  </div>
                  <div
                    *ngIf="
                      invalidTaxMessage &&
                      !f.WithHoldingState.disabled &&
                      !f.WithHoldingState.errors?.required
                    "
                    class="input-error show-untouched">
                    {{ invalidTaxMessage }}
                  </div>
                </div>
              </div>
              <!-- WORK STATE -->
              <div
                *ngIf="
                  selWHStateId &&
                  (selWHStateId.indexOf('Both') > -1 || selWHStateId == worksInState.Id)
                ">
                <div class="row" *ngIf="!(isStateIncomeWithHolding(worksInState.Id) | async)">
                  <div class="col-lg-12">
                    <em>No tax elections necessary.</em>
                  </div>
                </div>
                <div class="row" *ngIf="isStateIncomeWithHolding(worksInState.Id) | async">
                  <div class="col-lg-12">
                    <div *hasPermission="'employee_state_taxes_filing_status'">
                      <label
                        ><span *ngIf="selWHStateId && selWHStateId.indexOf('Both') > -1"
                          >{{ worksInState.Value }}&nbsp;</span
                        >Filing Status</label
                      >
                      <select formControlName="StateFilingStatus" class="form-control">
                        <option
                          *ngFor="
                            let status of getStateIncomeFilingStatuses(worksInState.Id) | async
                          "
                          value="{{ status.Id }}">
                          {{ status.Value }}
                        </option>
                      </select>
                      <div *ngIf="f.StateFilingStatus.errors?.required" class="input-error">
                        *required
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div *hasPermission="'employee_state_taxes_withholding_allowance'">
                      <label>Withholding Allowance</label>
                      <input
                        [formControl]="getControl('StateWithholdingAllowance')"
                        class="form-control"
                        maxlength="2"
                        appNumberInput
                        [decimals]="0"
                        [attr.disabled]="
                          f.StateWithholdingAllowance.disabled ? 'disabled' : null
                        " />
                      <div *ngIf="f.StateWithholdingAllowance.errors?.max" class="input-error">
                        *max number exceeded
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-6"
                    *ngIf="canHaveAdditionalAllowances(worksInState.Id) | async">
                    <div *hasPermission="'employee_state_taxes_additional_allowance'">
                      <label>Additional Allowances</label>
                      <input
                        [formControl]="getControl('StateAddlAllowances')"
                        class="form-control"
                        maxlength="2"
                        appNumberInput
                        [decimals]="0"
                        [attr.disabled]="f.StateAddlAllowances.disabled ? 'disabled' : null" />
                      <div *ngIf="f.StateAddlAllowances.errors?.max" class="input-error">
                        *max number exceeded
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div *hasPermission="'employee_state_taxes_fixed_withholding_type'">
                      <label>Fixed or Additional Withholdings</label>
                      <div class="radio-group flex-wrap justify-content-between">
                        <div>
                          <input
                            type="radio"
                            id="state-wh-radio-none"
                            name="StateAddlWithholdingType"
                            checked="true"
                            formControlName="StateAddlWithholdingType"
                            value="null" />
                          <label for="state-wh-radio-none"><span></span>None</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="state-wh-radio-additional-dollar"
                            formControlName="StateAddlWithholdingType"
                            name="StateAddlWithholdingType"
                            value="A" />
                          <label for="state-wh-radio-additional-dollar"
                            ><span></span>Additional Dollar</label
                          >
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="state-wh-radio-fixed-dollar"
                            formControlName="StateAddlWithholdingType"
                            name="StateAddlWithholdingType"
                            value="F" />
                          <label for="state-wh-radio-fixed-dollar"><span></span>Fixed Dollar</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="state-wh-radio-fixed-percent"
                            formControlName="StateAddlWithholdingType"
                            name="StateAddlWithholdingType"
                            value="P" />
                          <label for="state-wh-radio-fixed-percent"
                            ><span></span>Fixed Percent</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12" *ngIf="f.StateAddlWithholdingType.value != 'null'">
                    <div
                      class="input-group"
                      *hasPermission="'employee_state_taxes_fixed_withholding_value'">
                      <input
                        appNumberInput
                        [formControl]="getControl('StateAddlWithholdingValue')"
                        class="form-control"
                        [attr.disabled]="
                          f.StateAddlWithholdingValue.disabled ? 'disabled' : null
                        " />
                      <!-- additional dollar or fixed dollar -->
                      <div
                        class="input-group-prepend"
                        *ngIf="
                          f.StateAddlWithholdingType.value == 'A' ||
                          f.StateAddlWithholdingType.value == 'F'
                        ">
                        <span class="input-group-text">$</span>
                      </div>
                      <!-- fixed percent -->
                      <div
                        class="input-group-append"
                        *ngIf="f.StateAddlWithholdingType.value == 'P'">
                        <span class="input-group-text">%</span>
                      </div>
                      <div
                        *ngIf="
                          !f.StateAddlWithholdingValue.errors?.required &&
                          f.StateAddlWithholdingValue.errors
                        "
                        class="input-error input-group-error">
                        *invalid number
                      </div>
                      <div
                        *ngIf="f.StateAddlWithholdingValue.errors?.required"
                        class="input-error input-group-error">
                        *required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr *ngIf="selWHStateId.indexOf('Both') > -1" />
              <!-- HOME STATE -->
              <div
                *ngIf="
                  (selWHStateId.indexOf('Both') > -1 || selWHStateId == livesInState.Id) &&
                  livesInState.Id !== worksInState.Id &&
                  selWHStateId != ''
                ">
                <div class="row" *ngIf="!(isStateIncomeWithHolding(livesInState.Id) | async)">
                  <div class="col-lg-12">
                    <em>No tax elections necessary.</em>
                  </div>
                </div>
                <div class="row" *ngIf="isStateIncomeWithHolding(livesInState.Id) | async">
                  <div class="col-lg-12">
                    <div *hasPermission="'employee_state_taxes_addl_filing_status'">
                      <label
                        ><span *ngIf="selWHStateId.indexOf('Both') > -1"
                          >{{ livesInState.Value }}&nbsp;</span
                        >Filing Status</label
                      >
                      <select formControlName="AddlStateFilingStatus" class="form-control">
                        <option
                          *ngFor="
                            let status of getStateIncomeFilingStatuses(livesInState.Id) | async
                          "
                          value="{{ status.Id }}">
                          {{ status.Value }}
                        </option>
                      </select>
                      <div *ngIf="f.AddlStateFilingStatus.errors?.required" class="input-error">
                        *required
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div *hasPermission="'employee_state_taxes_addl_withholding_allowance'">
                      <label>Withholding Allowance</label>
                      <input
                        [formControl]="getControl('AddlStateWithholdingAllowance')"
                        class="form-control"
                        maxlength="2"
                        appNumberInput
                        [decimals]="0"
                        [attr.disabled]="
                          f.AddlStateWithholdingAllowance.disabled ? 'disabled' : null
                        " />
                      <div *ngIf="f.AddlStateWithholdingAllowance.errors?.max" class="input-error">
                        *max number exceeded
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-6"
                    *ngIf="canHaveAdditionalAllowances(livesInState.Id) | async">
                    <div *hasPermission="'employee_state_taxes_addl_additional_allowance'">
                      <label>Additional Allowances</label>
                      <input
                        [formControl]="getControl('AddlStateAddlAllowances')"
                        class="form-control"
                        maxlength="2"
                        appNumberInput
                        [decimals]="0"
                        [attr.disabled]="f.AddlStateAddlAllowances.disabled ? 'disabled' : null" />
                      <div *ngIf="f.AddlStateAddlAllowances.errors?.max" class="input-error">
                        *max number exceeded
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div *hasPermission="'employee_state_taxes_addl_withholding_type'">
                      <label>Fixed or Additional Withholdings</label>
                      <div class="radio-group flex-wrap justify-content-between">
                        <div>
                          <input
                            type="radio"
                            id="ex-state-wh-radio-none"
                            name="AddlStateAddlWithholdingType"
                            checked="true"
                            formControlName="AddlStateAddlWithholdingType"
                            value="null" />
                          <label for="ex-state-wh-radio-none"><span></span>None</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="ex-state-wh-radio-additional-dollar"
                            formControlName="AddlStateAddlWithholdingType"
                            name="AddlStateAddlWithholdingType"
                            value="A" />
                          <label for="ex-state-wh-radio-additional-dollar"
                            ><span></span>Additional Dollar</label
                          >
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="ex-state-wh-radio-fixed-dollar"
                            formControlName="AddlStateAddlWithholdingType"
                            name="AddlStateAddlWithholdingType"
                            value="F" />
                          <label for="ex-state-wh-radio-fixed-dollar"
                            ><span></span>Fixed Dollar</label
                          >
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="ex-state-wh-radio-fixed-percent"
                            formControlName="AddlStateAddlWithholdingType"
                            name="AddlStateAddlWithholdingType"
                            value="P" />
                          <label for="ex-state-wh-radio-fixed-percent"
                            ><span></span>Fixed Percent</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12" *ngIf="f.AddlStateAddlWithholdingType.value != 'null'">
                    <div
                      class="input-group"
                      *hasPermission="'employee_state_taxes_addl_withholding_value'">
                      <input
                        appNumberInput
                        [formControl]="getControl('AddlStateAddlWithholdingValue')"
                        class="form-control"
                        [attr.disabled]="
                          f.AddlStateAddlWithholdingValue.disabled ? 'disabled' : null
                        " />
                      <!-- additional dollar or fixed dollar -->
                      <div
                        class="input-group-prepend"
                        *ngIf="
                          f.AddlStateAddlWithholdingType.value == 'A' ||
                          f.AddlStateAddlWithholdingType.value == 'F'
                        ">
                        <span class="input-group-text">$</span>
                      </div>
                      <!-- fixed percent -->
                      <div
                        class="input-group-append"
                        *ngIf="f.AddlStateAddlWithholdingType.value == 'P'">
                        <span class="input-group-text">%</span>
                      </div>
                      <div
                        *ngIf="
                          !f.AddlStateAddlWithholdingValue.errors?.required &&
                          f.AddlStateAddlWithholdingValue.errors
                        "
                        class="input-error input-group-error">
                        *invalid number
                      </div>
                      <div
                        *ngIf="f.AddlStateAddlWithholdingValue.errors?.required"
                        class="input-error input-group-error">
                        *required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Invalid Local Resident Taxes-->
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['invalidResident'] }"
            *ngIf="
              (taxes | async).PreviousResidentState &&
              invalidResidentConfigs &&
              invalidResidentConfigs.length > 0 &&
              authService.canRead('employee_taxes_local_panel')
            ">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('invalidResident')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['invalidResident'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">
                Invalid Local Taxes ({{ (taxes | async).PreviousResidentState }})
              </h3>
              <div class="mt-3" *ngFor="let config of invalidResidentConfigs; let i = index">
                <div class="row">
                  <div class="col-lg-12" *hasPermission="'employee_local_tax_agency'">
                    <label [attr.title]="config.Instructions">
                      {{ config.TaxLabel }}
                    </label>
                    <input
                      class="form-control"
                      [disabled]="true"
                      value="{{
                        getLocalTaxPropValue(config.LocalTypeId, 'TaxCode', config) | async
                      }}" />
                  </div>
                  <div
                    class="col-lg-12"
                    *ngIf="getLocalTaxPropValue(config.LocalTypeId, 'FilingStatus', config)">
                    <div *hasPermission="'employee_local_tax_filing_status'">
                      <label>Filing Status</label>
                      <input
                        class="form-control"
                        [disabled]="true"
                        value="{{
                          getLocalTaxPropValue(config.LocalTypeId, 'FilingStatus', config) | async
                        }}" />
                    </div>
                  </div>
                  <div
                    class="col-lg-12"
                    *ngIf="
                      getLocalTaxPropValue(config.LocalTypeId, 'WithholdingAllowances', config)
                    ">
                    <div *hasPermission="'employee_local_tax_withholding_allowance'">
                      <label>Withholding Allowance</label>
                      <input
                        class="form-control"
                        [disabled]="true"
                        value="{{
                          getLocalTaxPropValue(config.LocalTypeId, 'WithholdingAllowances', config)
                            | async
                        }}" />
                    </div>
                  </div>
                </div>
                <hr style="margin-top: 0.25rem" *ngIf="i + 1 != invalidResidentConfigs.length" />
              </div>
            </div>
          </div>
          <!-- Invalid Local Works In Taxes -->
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['invalidWorksIn'] }"
            *ngIf="
              (taxes | async).PreviousWorksInState &&
              invalidWorksInConfigs &&
              invalidWorksInConfigs.length > 0 &&
              authService.canRead('employee_taxes_local_panel')
            ">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('invalidWorksIn')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['invalidWorksIn'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title">
                Invalid Local Taxes ({{ (taxes | async).PreviousWorksInState }})
              </h3>
              <div class="mt-3" *ngFor="let config of invalidWorksInConfigs; let i = index">
                <div class="row">
                  <div class="col-lg-12" *hasPermission="'employee_local_tax_agency'">
                    <label [attr.title]="config.Instructions">
                      {{ config.TaxLabel }}
                    </label>
                    <input
                      class="form-control"
                      [disabled]="true"
                      value="{{
                        getLocalTaxPropValue(config.LocalTypeId, 'TaxCode', config) | async
                      }}" />
                  </div>
                  <div
                    class="col-lg-12"
                    *ngIf="getLocalTaxPropValue(config.LocalTypeId, 'FilingStatus', config)">
                    <div *hasPermission="'employee_local_tax_filing_status'">
                      <label>Filing Status</label>
                      <input
                        class="form-control"
                        [disabled]="true"
                        value="{{
                          getLocalTaxPropValue(config.LocalTypeId, 'FilingStatus', config) | async
                        }}" />
                    </div>
                  </div>
                  <div
                    class="col-lg-12"
                    *ngIf="
                      getLocalTaxPropValue(config.LocalTypeId, 'WithholdingAllowances', config)
                    ">
                    <div *hasPermission="'employee_local_tax_withholding_allowance'">
                      <label>Withholding Allowance</label>
                      <input
                        class="form-control"
                        [disabled]="true"
                        value="{{
                          getLocalTaxPropValue(config.LocalTypeId, 'WithholdingAllowances', config)
                            | async
                        }}" />
                    </div>
                  </div>
                </div>
                <hr style="margin-top: 0.25rem" *ngIf="i + 1 != invalidWorksInConfigs.length" />
              </div>
            </div>
          </div>
          <!-- Local Taxes-->
          <div
            class="card"
            [ngClass]="{ 'expanded-card': cardExpanders['localTaxes'] }"
            *ngIf="
              localTaxConfigs &&
              localTaxConfigs.length > 0 &&
              authService.canRead('employee_taxes_local_panel')
            ">
            <div class="card-body">
              <a
                class="card-expander"
                (click)="toggleCardExpand('localTaxes')"
                title="Toggle tile expander">
                <i
                  class="fas"
                  [ngClass]="cardExpanders['localTaxes'] ? 'fa-compress' : 'fa-expand'">
                </i>
              </a>
              <h3 class="card-title" [ngClass]="{ 'mb-0 pb-0': requiredLocalTaxText }">
                Local Taxes
              </h3>
              <div *ngIf="requiredLocalTaxText" class="cp-green">
                <small>{{ requiredLocalTaxText }}</small>
              </div>
              <div
                *ngIf="localTaxStateNames && localTaxStateNames.length > 0"
                style="background-color: #fff2cc; margin-bottom: 15px; line-height: 1.25">
                <label class="mb-0">
                  For help selecting {{ localTaxStateNames.join(', ') }} local taxes see:
                </label>
                <div *ngFor="let url of localTaxStateUrls">
                  <a target="_blank" href="{{ url }}"
                    ><small>{{ url }}</small></a
                  >
                </div>
              </div>
              <div
                class="mt-3"
                formArrayName="Locals"
                *ngFor="let group of lControls; let i = index">
                <div *hasPermission="'employee_local_tax_agency'" [formGroupName]="i">
                  <input type="hidden" formControlName="LocalTypeId" />
                  <div *ngIf="selectByCounty[i]" class="row">
                    <div class="col-lg-12">
                      <label>County</label>
                      <select
                        class="form-control"
                        formControlName="County"
                        (ngModelChange)="onCountyChange(group, i)"
                        id="locals-{{ i }}-county">
                        <option></option>
                        <option *ngFor="let county of getLocalCounties()" value="{{ county }}">
                          {{ county }}
                        </option>
                      </select>
                      <div *ngIf="group.controls.County.errors?.required" class="input-error">
                        *required
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <label>Municipality</label>
                      <select
                        class="form-control"
                        formControlName="Municipality"
                        (ngModelChange)="onMuniChange(group, i)"
                        id="locals-{{ i }}-muni">
                        <option></option>
                        <option
                          *ngFor="let muni of getMunicipalities(group.value['County'])"
                          value="{{ muni }}">
                          {{ muni }} - {{ getMuniDescription(group.value['County'], muni) }}
                        </option>
                      </select>
                      <div *ngIf="group.controls.Municipality.errors?.required" class="input-error">
                        *required
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <label>School District</label>
                      <select
                        class="form-control"
                        formControlName="SchoolDistrict"
                        (ngModelChange)="onSchoolDistrictChange(group, i)"
                        id="locals-{{ i }}-school">
                        <option></option>
                        <option
                          *ngFor="
                            let district of getSchoolDistricts(
                              group.value['County'],
                              group.value['Municipality']
                            )
                          "
                          value="{{ district.SchoolCodeName }}">
                          {{ district.SchoolCodeName }}
                        </option>
                      </select>
                      <div
                        *ngIf="group.controls.SchoolDistrict.errors?.required"
                        class="input-error">
                        *required
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!selectByCounty[i]" class="row">
                    <div class="col-lg-12">
                      <label [attr.title]="getLocalConfig(group).Instructions">
                        {{ getLocalConfig(group).TaxLabel }}
                      </label>
                      <a
                        *ngIf="
                          getLocalConfig(group).IsSelectByCountyAvailable && !(readOnly | async)
                        "
                        class="float-end"
                        (click)="selectLocalsByCounty(group, i)">
                        <small>Select by county/muni</small>
                      </a>
                      <select
                        class="form-control"
                        formControlName="TaxCode"
                        (ngModelChange)="onLocalTaxChange(group, true)"
                        id="locals-{{ i }}-tax-code">
                        <option></option>
                        <option
                          *ngFor="let code of getLocalConfig(group).TaxCodes"
                          value="{{ code.Key }}">
                          {{ code.Key }} - {{ code.Value }}
                        </option>
                      </select>
                      <div *ngIf="group.controls.TaxCode.errors?.required" class="input-error">
                        *required
                      </div>
                      <div
                        class="input-error"
                        *ngIf="
                          !group.controls.TaxCode.errors?.required &&
                          group.controls.TaxCode.errors?.excludeFrom
                        ">
                        *{{ group.controls.TaxCode.errors?.excludeFrom.message }}
                      </div>
                      <div
                        class="input-error"
                        *ngIf="
                          !group.controls.TaxCode.errors?.required &&
                          group.controls.TaxCode.errors?.matchesOn
                        ">
                        *{{ group.controls.TaxCode.errors?.matchesOn.message }}
                      </div>
                    </div>
                    <div
                      class="col-lg-12"
                      *ngIf="
                        getLocalConfig(group).RequiresTaxElections &&
                        !getLocalConfig(group).UsesStateFilingStatus &&
                        getLocalFilingStatuses(group).length > 0
                      ">
                      <div *hasPermission="'employee_local_tax_filing_status'">
                        <label>Filing Status</label>
                        <select
                          class="form-control"
                          formControlName="FilingStatus"
                          (ngModelChange)="onLocalTaxChange(group)">
                          <option
                            *ngFor="let status of getLocalFilingStatuses(group)"
                            value="{{ status.Id }}">
                            {{ status.Value }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-12 mb-3" *ngIf="getLocalConfig(group).UsesStateFilingStatus">
                      <label class="mb-0">Filing Status</label><br />
                      <strong class="cp-green">
                        <em>
                          <small>Uses State Filing Status</small>
                        </em>
                      </strong>
                    </div>
                    <div class="col-lg-12" *ngIf="getLocalConfig(group).RequiresTaxElections">
                      <div *hasPermission="'employee_local_tax_withholding_allowance'">
                        <label>Withholding Allowance</label>
                        <input
                          class="form-control"
                          appNumberInput
                          maxlength="2"
                          [decimals]="0"
                          [formControl]="getLocalsControl('WithholdingAllowances', i)"
                          (ngModelChange)="onLocalTaxChange(group)"
                          [attr.disabled]="
                            group.controls.WithholdingAllowances.disabled ? 'disabled' : null
                          " />
                      </div>
                    </div>
                  </div>
                  <hr
                    style="margin-top: 0.25rem"
                    *ngIf="l.controls && i + 1 != l.controls.length" />
                  <!-- only show between local tax control groups -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
}
